import React, { Component } from 'react';
import { Container, Row } from "reactstrap";

class Contact extends Component {
    render() { 
        return ( 
            <div>
                <Container>
                    <Row>
                        <h2>Want to get in Touch</h2>
                        <p>If you want to contact me please email me at: <a href='mailto:vajramudita@gmail.com'>vajramudita@gmail.com</a> or alternativly you can use the contact form bellow.</p>
                    </Row>
                </Container>
            </div>
         );
    }
}
 
export default Contact;